function animateObserver() {
  // Only apply JavaScript animations on screens larger than 767px
  // For smaller screens, CSS takes care of showing elements without animation
  if (window.innerWidth > 991) {

    let anim = [...document.querySelectorAll(".animate")];

    let options = {
      rootMargin: "-20% 0px -20% 0px", // when element is 30% visible
      threshold: 0,
    };

    let animate = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.animation = `anim 0.7s ${entry.target.dataset.delay} forwards ease-out`;
        }
      });
    };

    let observer = new IntersectionObserver(animate, options);

    anim.forEach((item, idx) => {
      observer.observe(item);
    });


  }
}

export default animateObserver;
